import includes from 'lodash/includes';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { favoritePagesActions } from '@src/ducks/favoritePages';
import { postFavoritePage } from '@src/requests/favoritePages';

const isDuplicatePathError = (error) => {
    if (!error || !error.response) return false;
    if (error.response.status !== 422) return false;

    const data = error.response.data;
    if (!data) return false;

    return data.path && includes(data.path, 'has already been taken');
};

const useCreateFavoritePage = (config) => {
    const dispatch = useDispatch();

    const handleSuccess = () => {
        dispatch(favoritePagesActions.request());
        if (config && config.onSuccess) config.onSuccess();
    };

    const handleError = (error) => {
        if (isDuplicatePathError(error)) {
            // If we have duplicate path error we proccess it as success
            // because we already have this favorite page and we may
            // process it as just added.
            if (config && config.onSuccess) config.onSuccess();
        } else if (config.onError) {
            config.onError(error);
        }
    };

    return useMutation(
        postFavoritePage,
        {
            ...config,
            onSuccess: handleSuccess,
            onError: handleError,
        },
    );
};

export {
    useCreateFavoritePage,
};
